import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { formatDate } from '@angular/common';
import { AppConfig } from 'src/app/config/config';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  public pathApi = this.config.setting['pathApi'];
  public pathApiCommon = this.config.setting['pathApi'] + "Common/";

  constructor(private http: HttpClient, private config: AppConfig) { }

  replaceAll(data: string, searchText: string, replaceText: string): string {
    while (data.includes(searchText)) {
      data = data.replace(searchText, replaceText);
    }
    return data;
  }

  combinePaths(path1: string, path2: string): string {
    path1 = this.replaceAll(path1, '\\', '/');
    path2 = this.replaceAll(path2, '\\', '/');
    if (path1[path1.length - 1] === '/' && path2[0] === '/') path1 = path1.slice(0, -1);

    return path1 + path2;
  }

  getIntegrationTypes(): Observable<any>{
    return this.http.get<any>(`${this.pathApiCommon}GetJobIntegrationTypes`)
  }

  generateOptionsForBillPeriod(val:number,SLTNumberOfUsageDays:any,SLTStartDate:any,NSLTNumberOfUsageDays:any,NSLTStartDate:any):string[]{
    if(val == 1)
    {
      if(SLTNumberOfUsageDays== null || SLTNumberOfUsageDays == 0)
        return this.generateBillOptionsForMonthly();
      else
        return this.generateBillOptionsForNumberOfUsag(SLTNumberOfUsageDays, SLTStartDate)
    }else(val == 1)
    {
      if(NSLTNumberOfUsageDays == null)
        return this.generateBillOptionsForMonthly();
      else
        return this.generateBillOptionsForNumberOfUsag(NSLTNumberOfUsageDays, NSLTStartDate)
    }
  }

  private generateBillOptionsForMonthly(): string[]{
    var date = new Date();
    var billPeriodOptions:string[] = []
    for(let i=0; i<12; i++){
      let firstDay = formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'dd.MM.yyyy', 'en_US')
      let lastDay = formatDate(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'dd.MM.yyyy', 'en_US')
      let temp = firstDay.toString() + "-" + lastDay.toString()
      billPeriodOptions.push(temp)
      date.setMonth(date.getMonth()-1)
    }
    return billPeriodOptions;
  }

  private generateBillOptionsForNumberOfUsag(val:any,inputDate:any):string[]{
    var date = new Date();
    var billPeriodOptions:string[] = []
    if(val <= 0)
      return billPeriodOptions;
    var startDate = new Date(inputDate)
    if(startDate > date){
      while(startDate > date){
        startDate.setDate(startDate.getDate() - (val))
      }
    }else{
      while(startDate < date){
        startDate.setDate(startDate.getDate() + (val))
      }
    }

    date = startDate;
    for(let i=0; i<10; i++){
      date.setDate(date.getDate() - 1)
      let toDate = formatDate(date, 'dd.MM.yyyy', 'en_US')
      date.setDate(date.getDate() - (val - 1))
      let fromDate = formatDate(date, 'dd.MM.yyyy', 'en_US')
      let temp = fromDate.toString() + "-" + toDate.toString()
      billPeriodOptions.push(temp)
    }
    return billPeriodOptions;
  }
}
